<template>
  <section>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="isCancelable"></b-loading>
  </section>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      isLoading: false,
      isFullPage: true,
      isCancelable: true
    }
  },
  methods: {
    openLoading () {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 10 * 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/snippets/Loading.vue